"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Context = _interopRequireDefault(require("../../Context"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Custom React Hook to use Laquesis feature flags
 * It also triggers `window.isVariantEnabled` on client side when the functional component is used.
 * @param {String} featureFlag - Feature flag name
 * @param {{enable:boolean}} [options={ enable: true }] Right now it only has the option `enable`.
 *    The `enable` option is a precondition of the hook, since hooks can't be executed with conditionals.
 * @return {String|undefined} The feature flag if enabled, otherwise undefined
 */
const useFeatureFlag = (featureFlag, {
  enable
} = {
  enable: true
}) => {
  featureFlag = featureFlag.toUpperCase();
  const {
    featureFlags,
    isFeatureEnabled
  } = (0, _react.useContext)(_Context.default);
  const flagValue = featureFlags[featureFlag] ? featureFlag : undefined;

  // make sure during component re-renders that we only send one feature flag impression
  // also prepare for React 18 https://stackoverflow.com/questions/72238175/react-18-useeffect-is-getting-called-two-times-on-mount
  const flagImpressionSent = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (!enable || !flagValue || flagImpressionSent.current) {
      return;
    }
    isFeatureEnabled(flagValue);
    flagImpressionSent.current = true;
  }, [flagValue, isFeatureEnabled, enable]);
  if (!enable) {
    undefined;
  }
  return flagValue;
};
var _default = useFeatureFlag;
exports.default = _default;